export const redirectionTimeout = 10 * 1000; // 10 seconds
